import { Datagrid, ListProps, ReferenceField, TextField } from 'react-admin';
import { CustomList, MediaField, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function BrandsList(props: ListProps) {
  return (
    <CustomList 
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid 
        body={<SortableDatagridBody filterColumn="category" />} 
        rowClick="edit"
      >
        <MediaField label="Logo" source="logo" sortable={false} />

        <TextField label="Nome" source="name" sortable={false}/>

        <ReferenceField
          label="Categoria"
          source="category"
          reference="brands-categories"
          sortable={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
